import _ from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilState } from 'recoil';
import AssignmentPolicy from '../../assignmentPolicy/AssignmentPolicy';
import { cn } from '../../common/utils';
import Tabs, { TabItem } from '../../components/actions/Tabs';
import * as Icon from '../../components/icons';
import SidebarContainer, {
  SidebarContainerProps,
} from '../../containers/SidebarContainer';
import ProximityPolicyPanel from '../../proximityPolicy/ProximityPolicyPanel';
import SimulationItemSetWrap from '../hoc/SimulationItemSetWrap';
import { StoragePolicyTabId } from '../store/simulation.types';
import { simulationStorageTabKey } from '../store/simulation.wizard.state';
import ActionBarNextStep from './ActionBarNextStep';

const SimulationSidebarDatasetAssignmentPolicy: React.FC = () => {
  const { t } = useTranslation('simulation');

  const [selectedTab, setSelectedTab] = useRecoilState(simulationStorageTabKey);

  const tabIconStyle = cn('fill-current w-7 lg:w-8 xl:w-10 2xl:w-12 h-auto');

  const assignmentTabConfig: TabItem<StoragePolicyTabId> = {
    id: 'tab-policy-assignment',
    title: t`Storage Policy`,
    icon: <Icon.PolicyAssignment className={tabIconStyle} />,
    content: <AssignmentPolicy />,
  };

  const proximityTabConfig: TabItem<StoragePolicyTabId> = {
    id: 'tab-policy-proximity',
    title: t`Proximity Policy`,
    icon: <Icon.PolicySwap className={tabIconStyle} />,
    content: <ProximityPolicyPanel />,
  };

  const tabItems: TabItem<StoragePolicyTabId>[] = [
    assignmentTabConfig,
    proximityTabConfig,
  ];

  return (
    <SimulationItemSetWrap>
      <Tabs
        componentName="SimulationSidebarDatasetAssignmentPolicy"
        items={tabItems}
        selectedIndex={_.findIndex(tabItems, i => i.id === selectedTab)}
        onChange={index => setSelectedTab(tabItems[index].id)}
        hasScroll
        fullHeight
      />
      <ActionBarNextStep />
    </SimulationItemSetWrap>
  );
};

export default () => {
  const { t } = useTranslation('simulation');

  const containerProps: SidebarContainerProps = {
    type: 'sidebar-policy-storage',
    title: t`Storage Policy + Compliance`,
    loadingMessage: t`Loading Storage Policy...`,
    size: 'md',
  };

  return (
    <SidebarContainer key={containerProps.type} {...containerProps}>
      <SimulationItemSetWrap>
        <SimulationSidebarDatasetAssignmentPolicy />
      </SimulationItemSetWrap>
    </SidebarContainer>
  );
};
